import { handleActionRequest } from '@/actions/utils/handle-action-request'
import { API_ENDPOINT } from '@/actions/utils/api-client/api-endpoint'
import { smartPickProductsSchema } from '@/schemas/smart-picks/smart-pick-products'

export const getSmartPickProducts = async () => {
  return handleActionRequest({
    endpoint: API_ENDPOINT.smartPick.getSmartPickProducts(),
    schema: smartPickProductsSchema,
  })
}
